export default function getFilterParameters(filter, type) {
  if (filter) {
    let currentFilter = "?";
    for (let value in filter) {
      let id = filter[value].id;
      currentFilter += (id && id !== '' && !Array.isArray(id) && type !== value) ? `&${value}=${id}` : ''
      // для масивов (мультигорода)
      if (Array.isArray(id)){
        let cities = "";
        for (let city of id) {
          cities += city.id ? `${city.id},` : ''
        }
        cities = cities.substring(0, cities.length - 1);
        currentFilter += (cities && cities !== '') ? `&${value}=${cities}` : '';
      }
    }
    return currentFilter;
  }
}


// WEBPACK FOOTER //
// ./src/utils/getFilterParameters.js